// Robust, on-brand mock-data for Lederskab.nu - Det Landsdækkende Lederakademi

export const companyDetails = {
  name: "Lederskab.nu",
  address: "Parkvej 25 3. th., 7100 Vejle",
  phone: "+45 53 87 61 06",
  email: "anita@stressfrikommunikation.dk",
  slogan: "Tag ansvar for dit lederskab – ud fra dine værdier",
  stressfriUrl: "https://stressfrikommunikation.dk/",
  socials: {
    facebook: "https://www.facebook.com/profile.php?id=61590379900297",
    linkedin: "https://www.linkedin.com/company/lederskab-nu/?viewAsMember=true"
  }
};

export const images = {
  // Focus on people, workshops, and high-quality environments
  workshopHero: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/anita-workshop-hero.jpg",
  leadershipSection: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/fh1_1.jpg",
  sparringSection: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/nr12_1.jpg",
  groupDiscussion: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/a3a1743w-web.jpg",
  meetingEnvironment: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/1706599334579_1.jpg",
  presentation: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/a3a1619w-web_1.jpg",
  anitaPortrait: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/anita-portrait_1.webp",
  anitaPortraitConversation: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/anita-portrait.webp",
  officeEnvironment: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/kontoret2.webp",
  teamCircle: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/team-circle.webp",
  herContact: "https://assets.auxodev.dk/assets/22d442ab-45d9-4214-861d-1df67f744e88/1706599334649_2.jpg"
};

// 12-month leadership program modules
export const academyProgram = {
  title: "Tag ansvar for dit lederskab",
  subtitle: "12 måneders udviklingsforløb",
  description: "Et unikt, 12-måneders lederforløb designet til at integrere stærke ledelsesvaner over tid. Vi mødes til 4 intensive kursusdage fordelt over året, hvor vi arbejder i dybden med dit personlige lederskab, strategisk kommunikation og organisationskultur. Mellem modulerne arbejder du aktivt med implementering i din egen hverdag.",
  priceSingleDay: "8.495 kr.",
  priceFullProgram: "29.995 kr.",
  normalValue: "33.980 kr.",
  duration: "12 måneder (4 moduler - ét pr. kvartal)",
  location: "Afholdes i professionelle, lyse og inspirerende mødelokaler i hele Danmark (Vejle, Aarhus, København, Odense m.fl.)",
  
  modules: [
    {
      number: 1,
      title: "Fundamentet for dit lederskab",
      subtitle: "Modul 1",
      description: "Her lægger vi grundstenen for dit bevidste lederskab. Vi arbejder i dybden med dine personlige værdier, selvindsigt, dit personlige ansvar og din unikke ledelsesidentitet.",
      bullets: [
        "Dine personlige og professionelle værdier som kompas",
        "Øget selvindsigt og forståelse for egne reaktionsmønstre",
        "Det personlige ansvar som leder – at gå forrest",
        "Definition af din personlige ledelsesidentitet og autoritet"
      ]
    },
    {
      number: 2,
      title: "Kommunikation og relationer",
      subtitle: "Modul 2",
      description: "Fokus er på, hvordan du skaber stærke relationer og forebygger stress gennem klar, tillidsskabende og værdibaseret kommunikation.",
      bullets: [
        "StressFRI Kommunikation i praksis",
        "Aktiv lytning og empatisk ledelse",
        "Opbygning af tillid og psykologisk tryghed i dit team",
        "Konstruktive metoder til konflikthåndtering og svære samtaler"
      ]
    },
    {
      number: 3,
      title: "Ledelse i praksis",
      subtitle: "Modul 3",
      description: "Vi omsætter teori til konkrete hverdagsredskaber. Du lærer at prioritere, træffe svære beslutninger og skabe rammer, der fastholder medarbejdere.",
      bullets: [
        "Effektiv prioritering og tidsstyring under pres",
        "Beslutningsprocesser og tydelig forventningsafstemning",
        "Medarbejderudvikling og motivation",
        "Fastholdelse af medarbejdere af lyst fremfor pligt"
      ]
    },
    {
      number: 4,
      title: "Forankring",
      subtitle: "Modul 4",
      description: "Det sidste modul sikrer, at din læring og de nye vaner bliver en integreret del af din og virksomhedens langsigtede kultur.",
      bullets: [
        "Implementering af nye ledelsesværktøjer i hverdagen",
        "Skabe en sund og bæredygtig organisationskultur",
        "Vaneændringer og fastholdelse af egen udvikling",
        "Næste skridt på din lederrejse og personlige handlingsplan"
      ]
    }
  ]
};

// "What's in it for you" benefits
export const benefits = [
  {
    icon: "fa-solid fa-wind",
    title: "Skabe mere ro og overblik",
    description: "Lær at navigere i en travl hverdag uden at miste fodfæstet eller det strategiske overblik."
  },
  {
    icon: "fa-solid fa-comments",
    title: "Kommunikere tydeligere",
    description: "Undgå misforståelser og skab klarhed om mål, forventninger og rammer."
  },
  {
    icon: "fa-solid fa-users-gear",
    title: "Fastholde medarbejdere",
    description: "Skab en arbejdsplads, hvor medarbejdere trives og ønsker at blive af lyst."
  },
  {
    icon: "fa-solid fa-shield-heart",
    title: "Skabe psykologisk tryghed",
    description: "Etabler et tillidsfuldt rum, hvor fejl ses som læring, og alle tør sige deres mening."
  },
  {
    icon: "fa-solid fa-handshake-angle",
    title: "Håndtere konflikter tidligere",
    description: "Få modet og værktøjerne til at tage de svære samtaler, inden konflikterne vokser sig store."
  },
  {
    icon: "fa-solid fa-people-group",
    title: "Skabe stærkere samarbejde",
    description: "Nedbryd siloer og opbyg et fælles sprog og en stærk holdånd på tværs."
  },
  {
    icon: "fa-solid fa-gavel",
    title: "Træffe bedre beslutninger",
    description: "Styrk din beslutningskraft baseret på dine værdier og strategisk overblik."
  },
  {
    icon: "fa-solid fa-heart-pulse",
    title: "Lede uden at brænde ud",
    description: "Pas på dig selv som leder, så du kan holde til rollen og bevare energien over tid."
  },
  {
    icon: "fa-solid fa-route",
    title: "Omsætte værdier til handling",
    description: "Gør virksomhedens og dine egne værdier til konkrete handlinger i hverdagen."
  }
];

// Extensive Testimonials
export const testimonials = {
  lederne: [
    {
      quote: "Jeg kom til Anita i en periode, hvor jeg havde mistet retning og troen på mine egne evner. Gennem forløbet fik jeg genopbygget min selvtillid, blev mere bevidst om mine værdier og fandt modet til at tage ansvar for min fremtid. I dag står jeg i et nyt lederjob med langt større ro og klarhed.",
      author: "Jette",
      role: "Souschef, Harald Nyborg",
      rating: 5
    },
    {
      quote: "Jeg fik ikke bare nye værktøjer – jeg fik et nyt perspektiv på mit lederskab. Forløbet gav mig ro, retning og mod til at træffe de beslutninger, jeg længe havde udskudt. Jeg blev mere bevidst om mine værdier og min rolle som leder.",
      author: "Leder i detailbranchen",
      role: "Årsforløbsdeltager",
      rating: 5
    },
    {
      quote: "Jeg gik fra at reagere til at lede. Det mest værdifulde var tiden mellem modulerne. Jeg kunne afprøve værktøjerne i praksis og vende tilbage med konkrete erfaringer. Det gjorde læringen langt mere holdbar.",
      author: "Mellemleder i produktionsvirksomhed",
      role: "Årsforløbsdeltager",
      rating: 5
    },
    {
      quote: "Jeg blev en tydeligere leder uden at blive hårdere. Forløbet lærte mig, hvordan man kan skabe klare rammer og forventninger samtidig med, at man bevarer relationen til sine medarbejdere.",
      author: "Teamleder i servicebranchen",
      role: "Årsforløbsdeltager",
      rating: 5
    },
    {
      quote: "Da jeg startede forløbet, stod jeg et sted i mit arbejdsliv, hvor jeg havde mistet troen på mine egne evner og var i tvivl om næste skridt. Gennem arbejdet med mine værdier, mit ansvar og mit lederskab fik jeg genopbygget min selvtillid og fandt retningen igen. I dag står jeg i et nyt lederjob med langt større ro og klarhed.",
      author: "Jette",
      role: "Souschef",
      rating: 5
    },
    {
      quote: "Jeg lærte, at lederskab ikke handler om at kontrollere alt. Det handler om at skabe tydelighed, tillid og ansvar. Det har gjort mig til en bedre leder og givet mig mere overskud i hverdagen.",
      author: "Deltager på årsforløbet",
      role: "Leder",
      rating: 5
    }
  ],
  virksomhederne: [
    {
      quote: "Vi oplever i dag mere struktur, tydeligere ansvar, bedre samarbejde og mindre stress i hverdagen. Anita har været med til at skabe et fælles sprog omkring ledelse, forventninger og ansvar.",
      author: "El-Grossisten A/S",
      role: "Virksomhedsforløb",
      rating: 5
    },
    {
      quote: "Det var ikke endnu et kursus, hvor man bliver inspireret i en dag og glemmer det ugen efter. Forløbet over et år gav mig tid til at implementere, reflektere og udvikle mig mellem modulerne.",
      author: "Leder i en vækstvirksomhed",
      role: "Virksomhedskunde",
      rating: 5
    }
  ],
  samarbejdspartnerne: [
    {
      quote: "Det særlige ved Anita er, at hun ikke giver dig svarene. Hun hjælper dig med at finde dem selv. Det gør udviklingen langt mere ægte og holdbar.",
      author: "Lederudvikling med varig effekt",
      role: "Samarbejdspartner",
      rating: 5
    },
    {
      quote: "Mange kurser giver inspiration. Anita skaber handling. Der er en tydelig sammenhæng mellem refleksion, konkrete værktøjer og implementering i hverdagen.",
      author: "Fra indsigt til handling",
      role: "Strategisk partner",
      rating: 5
    }
  ]
};

// FAQ Questions and Answers
export const faqs = [
  {
    question: "Hvem er forløbet relevant for?",
    answer: "Forløbet er designet til ledere på alle niveauer, herunder ejerledere, mellemledere, teamledere, projektledere, produktionsledere samt nye ledere med personaleansvar. Det er også yderst relevant for erfarne ledere, der ønsker ny inspiration, refleksion og personlig udvikling."
  },
  {
    question: "Hvor mange deltagere er der på holdene?",
    answer: "For at sikre det maksimale udbytte, personlig sparring og et trygt, fortroligt rum, arbejder vi med små, eksklusive hold. Der er typisk omkring 10 deltagere pr. hold på vores 12-måneders lederforløb."
  },
  {
    question: "Hvad er inkluderet i forløbet?",
    answer: "Prisen inkluderer fuld undervisning på de 4 moduler, alt kursusmateriale, personlige handlingsplaner, adgang til netværk med andre ledere samt fuld professionel forplejning på alle kursusdage."
  },
  {
    question: "Er hotel og overnatning inkluderet?",
    answer: "Hotelovernatning er som udgangspunkt ikke inkluderet i standardprisen, men fuld dagsforplejning (morgenmad, frokost, kaffe/te, kage og snacks) på kursusstedet er altid inkluderet. Hvis du har brug for overnatning, hjælper vi gerne med at formidle kontakt til kursusstedet."
  },
  {
    question: "Kan virksomheden betale for mit forløb?",
    answer: "Ja, langt de fleste af vores deltagere får forløbet betalt af deres arbejdsgiver som led i deres professionelle efteruddannelse og udvikling. Vi sender fakturaen direkte til din virksomhed."
  },
  {
    question: "Kan man deltage enkeltvis?",
    answer: "Ja, absolut. Du kan tilmelde dig som enkeltperson på vores åbne hold, hvor du vil blive matchet med ledere fra andre brancher og virksomheder, hvilket giver en fantastisk mulighed for bred sparring."
  },
  {
    question: "Kan man sende flere ledere afsted fra samme virksomhed?",
    answer: "Ja, det anbefaler vi i høj grad. Når flere ledere fra samme virksomhed deltager, skabes der et fælles sprog, en fælles ledelseskultur og et stærkt internt netværk. Vi tilbyder attraktive virksomhedspakker med rabat, når I sender flere ledere afsted."
  },
  {
    question: "Hvor afholdes forløbet?",
    answer: "Forløbet afholdes i professionelle, lyse og inspirerende mødelokaler og konferencecentre fordelt over hele landet (f.eks. i Vejle, Aarhus, København, Odense), så det er nemt at komme til uanset geografi."
  },
  {
    question: "Hvad gør dette forløb anderledes end andre lederkurser?",
    answer: "Vi er ikke en traditionel kursusudbyder. Vi er et lederakademi. Vores fokus er ikke blot passiv undervisning, men reel transformation over tid. Ved at strække forløbet over 12 måneder med 4 moduler sikrer vi, at du har tid til at implementere værktøjerne i din egen praksis, reflektere over resultaterne og opbygge varige, sunde ledelsesvaner."
  },
  {
    question: "Hvilke resultater kan man forvente efter forløbet?",
    answer: "Du kan forvente at stå langt stærkere og mere roligt i din lederrolle. Du får konkrete værktøjer til at kommunikere tydeligt, forebygge stress, håndtere konflikter i opløbet, skabe psykologisk tryghed og fastholde dine medarbejdere. Du lærer at lede ud fra dine værdier, så dit lederskab holder i længden uden at du selv brænder ud."
  }
];

// Corporate Packages
export const corporatePackages = {
  title: "Udvikl stærke ledere sammen",
  subtitle: "Virksomhedsløsninger",
  description: "Når flere ledere fra samme virksomhed deltager på Lederskab.nu, skaber det en markant stærkere synergi. I opbygger et fælles sprog, en fælles ledelsesforståelse og en sund kultur, der styrker samarbejdet på tværs af hele organisationen.",
  benefits: [
    "Fælles sprog og ledelsesforståelse i organisationen",
    "Stærkere internt samarbejde og færre konflikter på tværs",
    "Fælles kultur baseret på værdibaseret ledelse og psykologisk tryghed",
    "Højere medarbejdertrivsel og reduceret stress i hele virksomheden"
  ],
  packages: [
    {
      range: "1-2 deltagere",
      price: "29.995 kr.",
      sub: "pr. deltager + moms",
      features: [
        "Komplet 12-måneders lederforløb",
        "4 intensive moduler",
        "Fuld forplejning og materialer",
        "Personlig handlingsplan"
      ]
    },
    {
      range: "3-5 deltagere",
      price: "27.995 kr.",
      sub: "pr. deltager + moms",
      features: [
        "Komplet 12-måneders lederforløb",
        "4 intensive moduler",
        "Fuld forplejning og materialer",
        "Personlig handlingsplan",
        "Sparring på tværs af jeres ledergruppe"
      ]
    },
    {
      range: "6-10 deltagere",
      price: "25.995 kr.",
      sub: "pr. deltager + moms",
      features: [
        "Komplet 12-måneders lederforløb",
        "4 intensive moduler",
        "Fuld forplejning og materialer",
        "Personlig handlingsplan",
        "4 strategiske ledersessioner mellem modulerne (Bonus)"
      ]
    },
    {
      range: "10+ deltagere",
      price: "Skræddersyet",
      sub: "Kontakt os for tilbud",
      features: [
        "Fuldt tilpasset virksomhedsforløb",
        "Afholdes internt hos jer eller eksternt",
        "Fokus på jeres specifikke strategiske mål",
        "Løbende strategisk ledersparring inkluderet"
      ]
    }
  ],
  bonus: "Bonus ved 5+ deltagere: 4 strategiske ledersessioner mellem modulerne for at sikre maksimal forankring i jeres specifikke virksomhedskontekst."
};

// Anita's background & stifter info
export const founderDetails = {
  name: "Anita Lauridsen",
  title: "Stifter af Lederskab.nu",
  subTitle: "Strategisk partner i ledelse og arbejdsmiljø",
  intro: "Jeg tror ikke på perfekte ledere. Jeg tror på bevidste ledere.",
  description: "Gennem mere end 20 år har jeg arbejdet med mennesker, drift, udvikling, forandringer og samarbejde. Som stifter af Lederskab.nu og strategisk partner i ledelse og arbejdsmiljø, hjælper jeg ledere og virksomheder over hele landet med at skabe mere retning, stærkere relationer og bæredygtige resultater.",
  approach: "Min tilgang er professionel, nærværende, tillidsskabende og handlingsorienteret. Jeg trækker på min omfattende praktiske erfaring fra komplekse driftsmiljøer og kombinerer den med stærk faglighed inden for ledelse, HR og psykisk arbejdsmiljø. Jeg hjælper dig med at finde svarene selv, så din udvikling bliver ægte og holdbar.",
  experienceBullets: [
    "20+ års erfaring med mennesker, drift og organisationsudvikling",
    "Erfaring fra komplekse brancher som transport, logistik, IT og projektledelse",
    "Uddannet inden for Ledelse, HR, Arbejdsmiljø og kognitiv kommunikation",
    "Certificeret Enneagram-praktiker med fokus på personlighedstyper i ledelse",
    "Stifter af Stressfri Kommunikation – specialist i stressforebyggelse og det psykiske arbejdsmiljø",
    "Erfaring med uddannelse og rådgivning af interessenter i hele Skandinavien, Storbritannien og Tyskland",
    "Har haft +200 ledere i forløb med fokus på at tage ansvar for eget lederskab"
  ]
};

export const aboutHer = {
  education: [
    {
      year: "Certificeret",
      title: "Certificeret Enneagram-praktiker",
      institution: "Professionelle Enneagram-uddannelser"
    },
    {
      year: "Uddannet",
      title: "Uddannelse inden for Ledelse, HR & Arbejdsmiljø",
      institution: "Erhvervsakademiske & faglige moduler med fokus på strategisk ledelse og psykisk arbejdsmiljø"
    },
    {
      year: "Uddannet",
      title: "Specialist i Stresshåndtering & Kognitiv Kommunikation",
      institution: "Certificerede uddannelsesforløb med fokus på forebyggelse og mental sundhed på arbejdspladsen"
    }
  ]
};
